import { Button } from "./button";

export class DropdownButton extends Button {
	parsedCallback() {
		const dropdown = this.querySelector("chip-dropdown");

		if (dropdown) {
			if ((this.buttonStyle === "icon" || !this.textContent?.trim()) && !this.description) {
				this.description = Localizer.TOGGLE_DROPDOWN;
			}

			if (!dropdown?.hasAttribute("icon")) { dropdown.icon = this.icon; }
			if (!dropdown?.hasAttribute("suffix-icon")) { dropdown.suffixIcon = this.suffixIcon; }
			if (!dropdown?.hasAttribute("size")) { dropdown.size = this.size; }
			if (!dropdown?.hasAttribute("description")) { dropdown.description = this.description; }
		}
	}

	click() {
		this.querySelector(":scope>chip-dropdown>div>.btn--base")?.click();
	}

	set textContent(value) {
		const button = this.querySelector("chip-dropdown>div>button");

		if (button) {
			button.textContent = value;
		}
	}
}